import React, { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';
export function LiveChatWidget() {
  const [open, setOpen] = useState(false);
  return <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3" data-id="element-170">
      {open && <div className="w-80 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden" data-id="element-171">
          <div className="px-4 py-3 flex items-center justify-between" style={{
        backgroundColor: '#1B8F4B'
      }} data-id="element-172">
            <div className="flex items-center gap-2" data-id="element-173">
              <div className="w-2 h-2 rounded-full bg-green-300 animate-pulse" data-id="element-174" />
              <span className="text-white text-sm font-semibold" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-175">
                Chat with us
              </span>
            </div>
            <button onClick={() => setOpen(false)} className="text-white/80 hover:text-white" data-id="element-176">
              <X className="w-4 h-4" data-id="element-177" />
            </button>
          </div>
          <div className="p-4 h-48 flex flex-col justify-end" data-id="element-178">
            <div className="bg-gray-100 rounded-xl rounded-tl-none p-3 text-sm text-gray-700 max-w-xs" data-id="element-179">
              👋 Hi! We typically reply within 30 minutes. How can we help you
              today?
            </div>
          </div>
          <div className="p-3 border-t border-gray-100 flex gap-2" data-id="element-180">
            <input type="text" placeholder="Type a message..." className="flex-1 text-sm px-3 py-2 rounded-lg border border-gray-200 focus:outline-none focus:border-[#1B8F4B]" data-id="element-181" />
            <button className="p-2 rounded-lg text-white" style={{
          backgroundColor: '#1B8F4B'
        }} data-id="element-182">
              <Send className="w-4 h-4" data-id="element-183" />
            </button>
          </div>
        </div>}
      <button onClick={() => setOpen(!open)} className="w-14 h-14 rounded-full text-white shadow-lg flex items-center justify-center transition-all duration-200 hover:scale-110 hover:shadow-xl" style={{
      backgroundColor: '#1B8F4B'
    }} aria-label="Open live chat" data-id="element-184">
        {open ? <X className="w-6 h-6" data-id="element-185" /> : <MessageCircle className="w-6 h-6" data-id="element-186" />}
      </button>
    </div>;
}